import React from "react";
import Calendar from "../components/media/Calendar"

export default function CalendarPage({ tenantId }) {
  return (
    <Calendar
      tenantId={tenantId}
      initialView="month"
    />
  );
}
